import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getSportsListStart,
    getSportsListSuccess,
    getSportsListFailure,
    getCountriesListStart,
    getCountriesListSuccess,
    getCountriesListFailure,
    getMatchesListStart,
    getMatchesListSuccess,
    getMatchesListFailure,
    getMarketsListStart,
    getMarketsListSuccess,
    getMarketsListFailure,
    getTournamentsListStart,
    getTournamentsListSuccess,
    getTournamentsListFailure,
    updateStatusStart,
    updateStatusSuccess,
    updateStatusFailure,
  },
  reducer
} = createSlice({
  name: 'sportsBook',
  initialState: {
    isGetSportsLoading: false,
    sportsListInfo: {},
    isGetCountriesLoading: false,
    sportsCountriesInfo: {},
    isGetMatchesLoading: false,
    sportsMatchesInfo: {},
    isGetMarketsLoading: false,
    sportsMarketsInfo: {},
    isGetTournamentLoading: false,
    sportsTournamentInfo: {}
  },
  reducers: {
    getSportsListStart: (state) => ({
      ...state,
      isGetSportsLoading: true
    }),
    getSportsListSuccess: (state, { payload }) => ({
      ...state,
      isGetSportsLoading: false,
      sportsListInfo: payload
    }),
    getSportsListFailure: (state, { payload }) => ({
      ...state,
      isGetSportsLoading: false
    }),
    getCountriesListStart: (state) => ({
      ...state,
      isGetCountriesLoading: true
    }),
    getCountriesListSuccess: (state, { payload }) => ({
      ...state,
      isGetCountriesLoading: false,
      sportsCountriesInfo: payload
    }),
    getCountriesListFailure: (state, { payload }) => ({
      ...state,
      isGetCountriesLoading: false
    }),
    getMatchesListStart: (state) => ({
      ...state,
      isGetMatchesLoading: true
    }),
    getMatchesListSuccess: (state, { payload }) => ({
      ...state,
      isGetMatchesLoading: false,
      sportsMatchesInfo: payload
    }),
    getMatchesListFailure: (state, { payload }) => ({
      ...state,
      isGetMatchesLoading: false
    }),
    getMarketsListStart: (state) => ({
      ...state,
      isGetMarketsLoading: true
    }),
    getMarketsListSuccess: (state, { payload }) => ({
      ...state,
      isGetMarketsLoading: false,
      sportsMarketsInfo: payload
    }),
    getMarketsListFailure: (state, { payload }) => ({
      ...state,
      isGetMarketsLoading: false
    }),
    getTournamentsListStart: (state) => ({
      ...state,
      isGetTournamentLoading: true
    }),
    getTournamentsListSuccess: (state, { payload }) => ({
      ...state,
      isGetTournamentLoading: false,
      sportsTournamentInfo: payload
    }),
    getTournamentsListFailure: (state, { payload }) => ({
      ...state,
      isGetTournamentLoading: false
    }),
    updateStatusStart: (state) => ({
      ...state,
      isGetSportsLoading: true
    }),
    updateStatusSuccess: (state, { payload }) => ({
      ...state,
      isGetSportsLoading: false,
      sportsTournamentInfo: payload
    }),
    updateStatusFailure: (state, { payload }) => ({
      ...state,
      isGetSportsLoading: false
    }),
  }
})

export default reducer
export {
  getSportsListStart,
  getSportsListSuccess,
  getSportsListFailure,
  getCountriesListStart,
  getCountriesListSuccess,
  getCountriesListFailure,
  getMatchesListStart,
  getMatchesListSuccess,
  getMatchesListFailure,
  getMarketsListStart,
  getMarketsListSuccess,
  getMarketsListFailure,
  getTournamentsListStart,
  getTournamentsListSuccess,
  getTournamentsListFailure,
  updateStatusStart,
  updateStatusSuccess,
  updateStatusFailure,
}
